import { Component, inject } from '@angular/core';
import { ActiveRoute } from '../active-route';
import { ViewportEnterDirective } from '../viewport-enter-directive';

@Component({
  selector: 'app-characteristics',
  standalone: true,
  imports: [ViewportEnterDirective],
  templateUrl: './characteristics.html',
  styleUrl: './characteristics.scss',
})
export class Characteristics {
  activeRoute= inject(ActiveRoute)
  
  
}

